<template>
  <li
    class="tag-item for-select"
    :class="$store.getters.getPackage !== 'premium' && text === '{default}' ? 'tag-item-close' : ''"
    style="white-space: nowrap;"
    :style="{ 'background-color': isError ? 'red' : '', color: isError ? 'white' : '' }"
  >
    <div style="display: flex; align-items: stretch">
      <div
        class="my-handle"
        style="display: inline-block; padding: 3px 5px 3px 5px; cursor: move; margin-left: 4px"
        v-if="isDrag"
      >
        <i class="fas fa-grip-vertical"></i>
      </div>
      <div class="ignore-elements" style="display: inline-block; padding: 0">
        <div
          style="white-space: normal"
          :style="{ 'border-left': !isDrag ? '0' : 'auto' }"
          class="tag"
          ref="tagInput"
          @focus="onFocusEditText()"
          maxlength="5"
          contenteditable="true"
          @blur="onBlurInput()"
          @input="update"
          v-on:keydown.enter.prevent="pressEnter"
          v-text="text"
        ></div>
      </div>

      <div class="ignore-elements" style="display: inline-block">
        <i
          class="fas fa-remove"
          v-if="!editText"
          style="padding: 6px 5px 2px; margin-right: 4px; cursor: pointer"
          @click="$emit('onDelete')"
        ></i>
        <i
          class="fas fa-pencil-alt"
          v-else
          style="padding: 6px 5px 2px; margin-right: 4px; cursor: pointer; color: white"
          @click="onBlurInput()"
        ></i>
      </div>
    </div>
    <SelectTag :isOpen="openSelector" :options="options" class="select" @addAndTag="addAndTag" />
  </li>
</template>

<script>
import AutoresizeTextarea from '@/components/elements/AutoresizeTextarea'
import SelectTag from '@/components/elements/SelectTag.vue'
export default {
  props: {
    options: {
      type: Array,
      default: []
    },
    value: '',
    isEdit: false,
    max: {
      type: Number,
      default: 0
    },
    maxlength: {
      type: Number,
      default: 0
    },
    isDrag: {
      type: Boolean
    }
  },
  components: {
    AutoresizeTextarea,
    SelectTag
  },
  data: function() {
    return {
      text: this.value,
      editText: false,
      isError: false,
      openSelector: false
    }
  },
  methods: {
    addAndTag: function(addText) {
      const checkDuplicateTag = this.text.split('&&').includes(addText)
      if (!checkDuplicateTag) {
        this.text = this.text + '&&' + addText
        if (this.text != this.$refs.tagInput.innerText) {
          this.$refs.tagInput.innerText = this.text
        }
        this.onBlurInput()
        this.editText = false
        this.openSelector = false
      } else {
        this.editText = false
        this.openSelector = false
      }
    },
    onFocusEditText: function() {
      this.editText = true
      this.openSelector = true
    },
    pressEnter: function(event) {
      this.onBlurInput()
    },
    onBlurInput: function() {
      setTimeout(() => {
        this.openSelector = false
      }, 200)
      var vm = this
      if (vm.noSpaceAndSpecial(vm.$refs.tagInput.innerText) == '') {
        vm.$emit('onDelete')
        return false
      } else {
        vm.$emit(
          'onChange',
          Object.assign(
            {},
            {
              tag: {
                // status: 'edit',
                text: vm.noSpaceAndSpecial(vm.$refs.tagInput.innerText)
              },
              addTag: function() {
                vm.$refs.tagInput.innerText = vm.noSpaceAndSpecial(vm.$refs.tagInput.innerText)

                vm.$emit('input', vm.noSpaceAndSpecial(vm.$refs.tagInput.innerText))
                vm.$emit('tags-changed')
                vm.editText = false
                vm.$refs.tagInput.blur()
              },
              error: function() {
                vm.isError = true
              }
            }
          )
        )
      }
    },
    update: function(event) {
      if (event.target.innerText.trim() == '') {
        return false
      }
      this.isError = false
    }
  },
  watch: {
    value: function(newVal, oldVal) {
      // console.log(newVal,this.$refs.tagInput.innerText)
      if (newVal != oldVal && newVal != this.$refs.tagInput.innerText) {
        this.$refs.tagInput.innerText = this.value
      }
      // this.text = this.value
    }
  }
}
</script>

<style scoped>
.for-select {
  position: relative;
  overflow: visible;
}
</style>



// WEBPACK FOOTER //
// src/components/elements/TagItem.vue